module.exports = __webpack_public_path__ + "static/Classeh-e8bdd2b81834c102c9e6d16f1bf645e5.svg";